var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,attrs:{"data-preload":[_vm.$options.name]}},[(_vm.priceTexts.isExchangePart && _vm.priceTexts.exchangePartValue !== 0)?_c('div',{staticClass:"priceText qa-PriceInfo__exchangePart"},[_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.$t('price-texts.exchange_part', {
          '%gross_exchange_part_value%': _vm.priceTexts.exchangePartValue,
        })
      )}})]):_vm._e(),_vm._v(" "),(_vm.priceTexts.description)?_c('div',{staticClass:"priceText qa-PriceInfo__description"},[_vm._v("\n    "+_vm._s(_vm.priceTexts.description)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.priceTexts.bulkyPrice)?_c('div',{staticClass:"priceText qa-PriceInfo__bulkyPrice",domProps:{"innerHTML":_vm._s(
      _vm.$t('price-texts.bulky_price', {
        '%formattedBulkyPrice%': _vm.priceTexts.bulkyPrice,
      })
    )}}):_vm._e(),_vm._v(" "),(_vm.priceTexts.riskyPrice)?_c('div',{staticClass:"priceText qa-PriceInfo__bulkyPrice",domProps:{"innerHTML":_vm._s(
      _vm.$t('price-texts.risky_price', {
        '%formattedRiskyPrice%': _vm.priceTexts.riskyPrice,
      })
    )}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }